import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getExportColumns } from 'api/org/per';
export default {
  props: {},
  data: function data() {
    return {
      visible: false,
      checkAll: false,
      checkedItems: [],
      allItems: [],
      isIndeterminate: true
    };
  },
  methods: {
    init: function init() {
      this.visible = true;
      this.checkedItems = [];
      this.allItems = [];
      this.isIndeterminate = true;
      this.checkAll = false;
      this.getField();
    },
    getField: function getField() {
      var _this = this;
      getExportColumns().then(function (data) {
        if (data.code === 1 && data.data instanceof Array) _this.allItems = data.data;
      });
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedItems = val ? this.allItems.map(function (i) {
        return i[0];
      }) : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.allItems.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allItems.length;
    },
    download: function download() {
      this.$emit('operate', this.checkedItems.join(','));
    }
  }
};